"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailSession = void 0;
const logger_1 = require("@streem/logger");
const logger_2 = require("../../util/logger");
const bookmark_controller_1 = require("../controllers/bookmark_controller");
const detection_controller_1 = require("../controllers/detection_controller");
const geolocation_controller_1 = require("../controllers/geolocation_controller");
const invitation_controller_1 = require("../controllers/invitation_controller");
const notes_controller_1 = require("../controllers/notes_controller");
const personalization_controller_1 = require("../controllers/personalization_controller");
const recording_controller_1 = require("../controllers/recording_controller");
const room_controller_1 = require("../controllers/room_controller");
const streemshot_controller_1 = require("../controllers/streemshot_controller");
const user_controller_1 = require("../controllers/user_controller");
const transcription_controller_1 = require("../controllers/transcription_controller");
const room_wall_1 = require("../wall/room_wall");
const wall_sync_builder_1 = require("../wall/wall_sync_builder");
class DetailSession {
    static initialize(config) {
        return __awaiter(this, void 0, void 0, function* () {
            return new DetailSession(config, yield new wall_sync_builder_1.RoomWallSyncBuilder(config.roomId, config.deviceId, config.userId, config.readOnly).build());
        });
    }
    constructor(config, wallSyncClient) {
        this.config = config;
        this.roomId = config.roomId;
        this.roomWall = new room_wall_1.RoomWall({
            alive: false,
            roomId: config.roomId,
            localUserId: config.userId,
            localDeviceId: config.deviceId,
            wallSyncClient: wallSyncClient,
        });
        this.bookmarks = new bookmark_controller_1.BookmarkController(this.controllerConfig);
        this.personalizations = new personalization_controller_1.PersonalizationController(this.controllerConfig);
        this.detection = new detection_controller_1.DetectionController(this.controllerConfig);
        this.geolocation = new geolocation_controller_1.GeolocationController(this.controllerConfig);
        this.invitations = new invitation_controller_1.InvitationController(this.controllerConfig);
        this.note = new notes_controller_1.NoteController(this.controllerConfig);
        this.recording = new recording_controller_1.RecordingController(this.controllerConfig);
        this.room = new room_controller_1.RoomController(this.controllerConfig);
        this.streemshots = new streemshot_controller_1.StreemshotController(this.controllerConfig);
        this.users = new user_controller_1.UserController(this.controllerConfig);
        this.transcription = new transcription_controller_1.TranscriptionController(this.controllerConfig);
        // Logs
        logger_2.logger.setContextValue(logger_1.contextValues.ROOM_ID, config.roomId.toString());
    }
    get controllerConfig() {
        return {
            roomWall: this.roomWall,
            context: {
                localUserId: this.config.userId,
                localDeviceId: this.config.deviceId,
                roomId: this.config.roomId,
            },
        };
    }
    connect() {
        return __awaiter(this, void 0, void 0, function* () {
            logger_2.logger.info(`The Detail session was created ${this.roomId}`);
            yield this.roomWall.connect();
        });
    }
    endSession() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.roomWall.disconnect();
            }
            catch (e) {
                logger_2.logger.error('Failed to disconnect Wall', e);
            }
            logger_2.logger.info(`The Detail session has ended ${this.roomId}`);
            logger_2.logger.removeContextValue(logger_1.contextValues.ROOM_ID);
        });
    }
}
exports.DetailSession = DetailSession;
//# sourceMappingURL=detail_session.js.map